import "./AthleteHLListDialog.scss";

import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {IAthlete, VideoFile} from "../10. Battle/types";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import NP from "../1. Core/NP";
import MultiBattleVideoGeneratorDialog from "../3. VideoEditor/MultiBattleVideoGeneratorDialog";
import {getViewName} from "../10. Battle/Util";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListBox from "../1. Core/Controls/ListBox/ListBox";
import {showShareDialog} from "../3. VideoEditor/func";
import ListItem from "../1. Core/Controls/ListBox/ListItem";


export default class AthleteHLListDialog extends Dialog {

	_Athlete: IAthlete;
	private _videoList: ListBox;

	constructor(props: any)
	{
		super(props);
	}


	_initFields(settings: object)
	{
		this._Athlete = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = getViewName(this._Athlete);
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._Width = 500;

	}

	_render()
	{
		super._render();

		this.addClass('athlete-hl-list-dialog')

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.add,
			EvClick: () =>
			{
				(new MultiBattleVideoGeneratorDialog({
					Athlete: this._Athlete,
					EvClosed: () => this.updateList()
				})).show();
			}
		}));


		this._videoList = new ListBox({
			Selectable: true,
			EvItemClick: (s: object, e: { Item: ListItem }) =>
			{
				showShareDialog(e.Item.getValue())
			},
			TwoLines: true,
			Class: 'app-list--non-interactive selectable',
			ParentNode: this._contentNode
		})

		this._cancelButton.hide();

		this.updateList()
	}

	async updateList()
	{
		let files = await ServerAPI.get<VideoFile[]>(`/video/athlete-video-items/${this._Athlete.Id}`)
		this._videoList.setItems(files.map(f => ({
			Content: f.Name,
			SecondLine: f.Created,
			Value: f,
		})))
	}
}